import { render, staticRenderFns } from "./UnidadCompuesta.vue?vue&type=template&id=751c8023&scoped=true&"
import script from "./UnidadCompuesta.vue?vue&type=script&lang=js&"
export * from "./UnidadCompuesta.vue?vue&type=script&lang=js&"
import style0 from "./UnidadCompuesta.vue?vue&type=style&index=0&id=751c8023&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751c8023",
  null
  
)

export default component.exports